module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/sorority-2-7d0c6b5a6a1901703b5fd78a0ebebb0d.jpg";